import { useEffect, useRef } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebase.config';

export function useUserEventEffects({
  isFullAccount,
  setShowSuccessNotification,
  setShowSalesPrompt,
  setShowSigninSuccessBanner,
}) {
  useEffect(() => {
    const handleCreditsIncrease = (event) => {
      console.log('[App] Credits increased event received:', event.detail);
      console.log('[App] Setting showSuccessNotification to true');
      setShowSuccessNotification(true);

      setTimeout(() => {
        console.log('[App] Auto-hiding success notification');
        setShowSuccessNotification(false);
      }, 5000);
    };

    console.log('[App] Setting up creditsIncreased event listener');
    window.addEventListener('creditsIncreased', handleCreditsIncrease);
    return () => {
      console.log('[App] Removing creditsIncreased event listener');
      window.removeEventListener('creditsIncreased', handleCreditsIncrease);
    };
  }, [setShowSuccessNotification]);

  useEffect(() => {
    const handler = () => setShowSalesPrompt(true);
    window.addEventListener('salesPrompt', handler);
    return () => window.removeEventListener('salesPrompt', handler);
  }, [setShowSalesPrompt]);

  const wasFullAccountRef = useRef(isFullAccount);
  useEffect(() => {
    let timeoutId;

    const checkAndShowBanner = async () => {
      if (!wasFullAccountRef.current && isFullAccount) {
        try {
          const auth = getAuth();
          const user = auth.currentUser;
          if (!user) return;

          const userRef = doc(db, 'users', user.uid);
          const snap = await getDoc(userRef);
          const data = snap.exists() ? snap.data() : {};

          if (!data?.signinSuccessBannerShown) {
            setShowSigninSuccessBanner(true);
            timeoutId = setTimeout(() => setShowSigninSuccessBanner(false), 5000);
            await setDoc(userRef, { signinSuccessBannerShown: true }, { merge: true });
          }
        } catch (error) {
          console.error('[App] Failed to determine whether to show sign-in success banner', error);
        }
      }

      wasFullAccountRef.current = isFullAccount;
    };

    checkAndShowBanner();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [setShowSigninSuccessBanner, isFullAccount]);
}
